import React from 'react'

const GamingHeaderIconWhite = ({ className, size = 32 }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="white-glow-gaming">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      <path 
        d="M4 14C4 11.7909 5.79086 10 8 10H24C26.2091 10 28 11.7909 28 14V18C28 20.2091 26.2091 22 24 22H8C5.79086 22 4 20.2091 4 18V14Z" 
        stroke="#ffffff" 
        strokeWidth="2"
        filter="url(#white-glow-gaming)"
      />
      
      <line x1="10" y1="16" x2="14" y2="16" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"/>
      <line x1="12" y1="14" x2="12" y2="18" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"/>
      
      <circle cx="20" cy="14" r="1.5" fill="#ffffff"/>
      <circle cx="23" cy="16" r="1.5" fill="#ffffff"/>
      <circle cx="20" cy="18" r="1.5" fill="#ffffff"/>
      <circle cx="17" cy="16" r="1.5" fill="#ffffff"/>
      
      <path d="M8 22C6 23 4 24 4 26" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
      <path d="M24 22C26 23 28 24 28 26" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
      
      <path d="M16 6L16 10" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
      <path d="M12 7L11 10" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
      <path d="M20 7L21 10" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
      
      <circle cx="16" cy="4" r="1.5" fill="#ffffff" opacity="0.8"/>
    </svg>
  )
}

export default GamingHeaderIconWhite
